import React from "react"
import { Icon } from "@iconify/react"

const LearnMore = ({ toggle, heading, initialMessage }) => {
  return (
    <div className="learnmore">
      <div className="close-icon">
        <Icon icon="ei:close" width="40" height="40" onClick={toggle} />
      </div>
      <h2>{heading}</h2>
      <form
        name="solutions-learnMore"
        id="solutions-learnMore"
        method="POST"
        data-netlify="true"
        action="/thank-you/success"
        netlify-honeypot="bot-field"
      >
        <p className="hidden" hidden>
          <label>
            Don’t fill this out if you’re human: <input name="bot-field" />
          </label>
        </p>
        <input
          type="hidden"
          name="form-name"
          value="solutions-learnMore"
        ></input>
        <input type="text" placeholder="Name *" name="name" required />
        <input type="email" placeholder="Email *" name="email" required />
        <input type="text" placeholder="Phone" name="phone" />
        <input type="text" placeholder="Company" name="company-name" />
        <textarea
          typeof="text"
          rows={3}
          placeholder="Message"
          defaultValue={initialMessage}
          name="message"
        ></textarea>
        <button type="submit" className="learn-more-link link-btn">
          Let's go!
        </button>
      </form>
    </div>
  )
}

export default LearnMore
